import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

export default class SubtitleTimelineTimeSection extends PureComponent {
  static propTypes = {
    time: PropTypes.number
  };

  static defaultProps = {
    time: 1
  };

  render() {
    const { time } = this.props;

    return <div className="subtitle__timeline__time__section">{time}</div>;
  }
}
